export default "__VITE_ASSET__mpypRlNO__"